// Acquirers
export type { AudioOptions } from '@uppy/audio'
// Uploaders
export type { AwsS3Options } from '@uppy/aws-s3'
export type { BoxOptions } from '@uppy/box'
// Miscellaneous
export type { CompressorOptions } from '@uppy/compressor'
// Core
export type { UIPluginOptions, UppyOptions } from '@uppy/core'
// UI plugins
export type { DashboardOptions } from '@uppy/dashboard'
export type { DragDropOptions } from '@uppy/drag-drop'
export type { DropTargetOptions } from '@uppy/drop-target'
export type { DropboxOptions } from '@uppy/dropbox'
export type { FacebookOptions } from '@uppy/facebook'
export type { FormOptions } from '@uppy/form'
export type { GoldenRetrieverOptions } from '@uppy/golden-retriever'
export type { GoogleDriveOptions } from '@uppy/google-drive'
export type { ImageEditorOptions } from '@uppy/image-editor'
export type { InstagramOptions } from '@uppy/instagram'
export type { OneDriveOptions } from '@uppy/onedrive'
export type { RemoteSourcesOptions } from '@uppy/remote-sources'
export type { ScreenCaptureOptions } from '@uppy/screen-capture'
export type { StatusBarOptions } from '@uppy/status-bar'
export type { ThumbnailGeneratorOptions } from '@uppy/thumbnail-generator'
export type { TransloaditOptions } from '@uppy/transloadit'
export type { TusOptions } from '@uppy/tus'
export type { UnsplashOptions } from '@uppy/unsplash'
export type { UrlOptions } from '@uppy/url'
export type { WebcamOptions } from '@uppy/webcam'
export type { XHRUploadOptions } from '@uppy/xhr-upload'
export type { ZoomOptions } from '@uppy/zoom'
export * from './bundle.js'
